"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Blitz = void 0;
var _pixi = require("pixi.js");
var _RingHandler = require("./RingHandler");
var _Stats = require("./Stats");
var _StarWarp = _interopRequireDefault(require("./StarWarp"));
var _FilterManager = _interopRequireDefault(require("./FilterManager"));
var _Background = _interopRequireDefault(require("./Background"));
var _BlitzLogo = require("./BlitzLogo");
var _BlitzInfo = require("./BlitzInfo");
var _BlitzSplashScreenDesktop = require("./splashscreen/BlitzSplashScreenDesktop");
var _RangeInput = require("./RangeInput");
var _core = require("@dragon/core");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Blitz = exports.Blitz = /*#__PURE__*/function (_Container) {
  /**
   * Currently only support spine logo's.
   *
   * @param application
   * @param colorSet
   * @param logoAnimationName
   */
  function Blitz(application, logoConfig, colorSet, blitzInfoConfig) {
    var _this;
    _classCallCheck(this, Blitz);
    _this = _callSuper(this, Blitz);
    _defineProperty(_this, "contentContainer", void 0);
    _defineProperty(_this, "ringHandler", void 0);
    _defineProperty(_this, "stats", void 0);
    _defineProperty(_this, "ringScale", void 0);
    _defineProperty(_this, "background", void 0);
    _defineProperty(_this, "warpXbet", 10);
    _defineProperty(_this, "starWarp", void 0);
    _defineProperty(_this, "filterManager", void 0);
    _defineProperty(_this, "warpTimeout", void 0);
    _defineProperty(_this, "blitzOn", void 0);
    _defineProperty(_this, "application", void 0);
    _defineProperty(_this, "logo", void 0);
    _defineProperty(_this, "_defaultColorSet", {
      topGradientStandard: 0x97e48c,
      topGradientWarp: 0x00fff7,
      bottomGradientStandard: 0xed3bff,
      bottomGradientWarp: 0xfff300,
      topSmokeStandard: 0xff00ff,
      topSmokeWarp: 0xd4ff00,
      bottomSmokeStandard: 0x00fffb,
      bottomSmokeWarp: 0xff3200,
      centerZoneStandard: 0x000000,
      centerZoneWarp: 0x000000,
      annulusWarp: 0x000000
    });
    _defineProperty(_this, "betCoinValue", void 0);
    _defineProperty(_this, "info", void 0);
    _defineProperty(_this, "splashScreen", void 0);
    _defineProperty(_this, "rangeInput", void 0);
    _defineProperty(_this, "_flyingWins", void 0);
    _defineProperty(_this, "closeTween", void 0);
    _defineProperty(_this, "handleResize", function (c) {
      // off set center to be a bit higher up to leave more space below.
      var yOffset = c.height * 0.12;
      switch (c.channel) {
        case _core.Channel.Mobile:
          {
            switch (c.orientation) {
              case _core.Orientation.Landscape:
                {
                  _this.rangeInput.scale.set(1);
                  _this.rangeInput.y = c.height / 2 - _this.rangeInput.height / 2;
                  _this.rangeInput.x = c.width - 100;
                  _this.rangeInput.showHeader();
                  _this.rangeInput.setVertical();
                  var scale = c.scaleFactor * 1.5;
                  if (scale > 1) {
                    scale = 1;
                  }
                  _this.rangeInput.scale.set(scale);
                  yOffset = c.height * 0.06;
                  _this.rangeInput.x = 50;
                  _this.rangeInput.y = c.height / 2 - _this.rangeInput.height / 2;
                  break;
                }
              case _core.Orientation.Portrait:
                {
                  _this.rangeInput.setHorizontal();
                  if (c.height > 850) {
                    _this.rangeInput.y = c.height * 0.775;
                  } else if (c.height > 600) {
                    _this.rangeInput.y = c.height * 0.785;
                  } else _this.rangeInput.y = c.height * 0.77;
                  _this.rangeInput.x = c.width * 0.04;
                  _this.rangeInput.scale.set(0.5);
                  if (c.width > 700) {
                    _this.rangeInput.x = c.width * 0.1;
                    _this.rangeInput.scale.set(1);
                  }
                  break;
                }
            }
            break;
          }
        case _core.Channel.Desktop:
          {
            _this.rangeInput.setHorizontal();
            _this.rangeInput.x = c.width / 2 - 560 * c.scaleFactor;
            _this.rangeInput.y = c.height * 0.87;
            _this.rangeInput.scale.set(c.scaleFactor);
          }
      }
      _this.ringHandler.ring.x = c.width / 2;
      _this.ringHandler.ring.y = c.height / 2;
      _this.ringHandler.ring.y -= yOffset;
      _this.ringHandler.ring.scale.set(1);
      _this.ringHandler.ring.scale.set(c.scaleFactor);

      // scaling ring over 1 gives weird effects, we should never do that.
      _this.ringScale = _this.ringHandler.ring.scale.x <= 1 ? _this.ringHandler.ring.scale.x : 1;
      _this.starWarp.resize(c.height + yOffset, c.width);
      _this.starWarp.position = _this.ringHandler.ring.position;
      _this.filterManager.resize(c.height, c.width, yOffset, _this.ringScale);
      _this.background.resize(c.width, c.height, yOffset);
    });
    _defineProperty(_this, "tick", function () {
      _this.starWarp.update();
      _this.background.update();
    });
    //Close Ring
    _defineProperty(_this, "close", function () {
      if (_this.info) _this.info.hide();
      _gsap["default"].to(_this, {
        duration: 0.5,
        alpha: 0
      });
      _this.closeTween = _gsap["default"].to(_this.ringHandler.ring.scale, {
        duration: 0.5,
        ease: 'power2.in',
        x: 0,
        y: 0,
        onComplete: function onComplete() {
          _this.visible = false;
          _this.application.ticker.remove(_this.tick);
        }
      });
    });
    _defineProperty(_this, "open", function () {
      if (_this.info) _this.info.show();
      _this.application.ticker.add(_this.tick);
      if (_this.closeTween) _this.closeTween.kill();
      _this.visible = true;
      _gsap["default"].to(_this, {
        alpha: 1,
        duration: 0.5
      });
      var t = 'back.inOut(1)';
      _gsap["default"].to(_this.ringHandler.ring.scale, {
        duration: 1,
        ease: t,
        x: _this.ringScale,
        y: _this.ringScale
      });
    });
    _this.application = application;
    _this.name = "blitzContainer";
    _this.visible = false;
    application.stage.addChild(_this);
    _this.contentContainer = new _pixi.Container();
    _this.addChild(_this.contentContainer);
    _this.background = new _Background["default"](_this, _this.application.renderer.view.width, _this.application.renderer.view.height, colorSet ? colorSet : _this._defaultColorSet);
    _this.contentContainer.addChild(_this.background);
    _this.ringHandler = new _RingHandler.RingHandler(application.renderer);
    var screen = _core.CORE.getState().config.screenSize;
    _this.starWarp = new _StarWarp["default"](_this, screen.width, screen.height);
    _this.contentContainer.addChild(_this.starWarp);
    _this.filterManager = new _FilterManager["default"](_this, _this.starWarp); // Creates the manager for the filters such as the blur filter on the edge
    _this.filterManager.setBlurEffect(true);
    var ring = _this.ringHandler.createRing({});
    _this.contentContainer.addChild(ring);
    _this.stats = new _Stats.Stats(_this.contentContainer);
    if (logoConfig.type !== _BlitzLogo.BlitzLogoType.None) _this.logo = new _BlitzLogo.BlitzLogo(_this.contentContainer, logoConfig);
    var config = _core.CORE.getState().config;
    if (config.channel == _core.Channel.Desktop) _this.info = new _BlitzInfo.BlitzInfo(_this.contentContainer, blitzInfoConfig);

    //#region slider
    _this.rangeInput = new _RangeInput.RangeInput(config.blitzMinRounds, config.blitzMaxRounds, "blitz.rounds", _core.BLITZ_SET_ROUNDS, false);
    _this.addChild(_this.rangeInput);
    _this.contentContainer.interactiveChildren = false;
    ////#endregion
    //#region blitzsplashscreen

    if (!config.blitzSplashScreenHide) {
      _this.splashScreen = new _BlitzSplashScreenDesktop.BlitzSplashScreenDesktop(_this, config.locale);
      _this.splashScreen.show();
      _this.rangeInput.hide();
      var blurFilter = new _pixi.filters.BlurFilter();
      _this.contentContainer.filters = [blurFilter];
      blurFilter.blur = 10;
      blurFilter.blurY = 10;
      _core.CORE.subscribe("blitz.splashScreen", function (a) {
        if (!a) {
          _this.contentContainer.filters = [];
          _this.splashScreen.hide();
          _this.rangeInput.show();
        }
      });
    }
    //   this.addChild(new PixiGameRuler());
    //#endregion

    _core.CORE.subscribe("blitz.on", function (a) {
      _this.blitzOn = a;
    });
    _core.CORE.subscribe("config.screenSize", _this.handleResize);
    _core.CORE.subscribe("blitz.totalWon", function (e) {
      _this.ringHandler.setPrice(e);
    });
    _core.CORE.subscribe("blitz.ringText", function (e) {
      _this.ringHandler.setText(e);
    });
    _core.CORE.subscribe("blitz.roundsPlayed", function (e) {
      if (_this.blitzOn) _this.ringHandler.pulse(_core.CORE.getState().blitz.lastCoinsWon);
    });

    // Features based on win x bet.
    _core.CORE.subscribe("blitz.lastCoinsWon", function (e) {
      // don't warp if blitz is off. this should prevent starting blitz mode and warping after a bonus game.
      if (!_this.blitzOn) return;
      if (e && _this._flyingWins) _this.ringHandler.flyText((0, _core.coinsToCurrency)(e));
      if (e >= _this.betCoinValue * _this.warpXbet) {
        _this.ringHandler.colorChange(false, true);
        _this.starWarp.startWarp(2000);
        _this.filterManager.setBlurEffect(false);
        setTimeout(function () {
          _this.filterManager.pulse();
        }, 400);
      }
    });
    _core.CORE.subscribe("bet.coinValue", function (e) {
      _this.betCoinValue = e;
    });
    _core.CORE.subscribe("blitz.flyingWins", function (e) {
      _this._flyingWins = e;
    });
    _core.CORE.subscribe("blitz.playing", function (e) {
      if (e) {
        _this.ringHandler.colorChange(true);
        _this.background.warpStart();
        _this.background.fireAnnulus();
      } else {
        _this.background.warpEnd();
        _this.starWarp.stopWarp();
        _this.ringHandler.colorChange(false);
      }
    });
    return _this;
  }
  _inherits(Blitz, _Container);
  return _createClass(Blitz);
}(_pixi.Container);
//# sourceMappingURL=Blitz.js.map